import React from 'react';
import { Grid, Typography } from '@mui/material';
import BackButton from '../elements/BackButton';
import ShareButton from '../elements/ShareButton';

interface EventHeaderProps {
    eventName: string;
    eventLocation: string;
    onShare: () => void;
}

const EventHeader: React.FC<EventHeaderProps> = ({ eventName, eventLocation, onShare }) => {
    return (
    <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
        <Grid item xs={12} className="hide-mobile" mt={5} mb={1}>
            <BackButton />
        </Grid>
        <Grid item xs={12} sm={9} className="hide-mobile">
            <Typography variant="h4" className='mobile-small-h1 fw-700'>{eventName}</Typography>
            <Typography variant="h6" className="event-group-location-title">{eventLocation}</Typography>
        </Grid>
        <Grid item xs={12} sm={3} container justifyContent="flex-end" className="hide-mobile">
            <ShareButton onClick={onShare} />
        </Grid>
        <Grid item xs={12} sm={12} className="hide-mobile" mb={4}>
            <hr/>
        </Grid>
        <Grid item xs={12} className="hide-md" mt={2}>
            <Grid container justifyContent="space-between" alignItems="center">
                <BackButton />
                <ShareButton onClick={onShare} />
            </Grid>
        </Grid>
        <Grid item xs={12} className="hide-md" mb={2}>
            <Typography variant="h1" className='mobile-small-h1 fw-700' mt={1}>{eventName}</Typography>
            <Typography variant="h6" className="event-group-location-title" mb={2}>{eventLocation}</Typography>
            <hr />
        </Grid>
    </Grid>
    );
};

export default EventHeader;